import carChatActions from "actions/carChat";
import cn from "classnames";
import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import ExpressBidIcon from "components/shared/expressBidIcon";
import List from "components/shared/list";
import Loader from "components/shared/loader";
import Notifys from "components/shared/notifys";
import Select, { customFilterSelectStyles, defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import WithMentions from "components/shared/withMentions";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { connect, generatedActions, tableDispatchToProps, tableStateToProps } from "helpers/redux";
import { mergeFilters } from "helpers/reqparams";
import { ymEvent } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { numbersList as trucksList } from "sources/books/trucks";
import { addChatToFavorites, removeChatFromFavorites } from "sources/carChats";

class CarChatsList extends BookIndex {
    state = { loadingItems: [] };

    renderHead = () => {
        const { title, params } = this.props;
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">
                    {title}
                    <div className="ml-2 btn btn-xs btn-outline-primary" onClick={this.readAllMessages}>
                        <i className="icon-uEA54-checkmark inline-icon mr-1 small" />
                        Прочитать все
                    </div>
                </div>
                <div className="btn-toolbar">
                    <div className="mr-2 d-flex align-items-center">
                        <div
                            className={cn("b-filter__tag--wrap mb-0", {
                                "b-filter__tag--wrap-selected": params.customFilters?.onlyNew,
                            })}
                            onClick={() => this.setFilter({ name: "onlyNew", value: !params.customFilters?.onlyNew })}
                        >
                            <span
                                className={
                                    params.customFilters?.onlyNew ? "b-filter__tag--delete" : "b-filter__tag--checkbox"
                                }
                            />
                            <span className="b-filter__tag--text">Непрочитанные</span>
                        </div>
                    </div>
                    <Link
                        to={`${paths.profileAccount}?tab=notification-settings`}
                        className="font-size-12 nowrap-text"
                        onClick={() => ymEvent("NotificationsSettingsClicked")}
                    >
                        <i className="icon-uEA0C-gear inline-icon pr-1" />
                        Настройки уведомлений
                    </Link>
                </div>
            </div>
        );
    };

    readAllMessages = () => {
        const { modal, readAllCarChats } = this.props;
        return modal({
            name: "confirm",
            title: "Подтверждение действия",
            text: "Вы уверены, что хотите отметить все сообщения прочитанными?",
            callback: null,
            action: () => readAllCarChats(),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    toChat = (id, unreadMessagesCount) => {
        if (unreadMessagesCount > 0) {
            this.props.readCarChat({ chatId: id });
        }
        this.props.history.push(paths.carChatsShow(id));
    };

    renderTableRow = ({
        id,
        title,
        text,
        lastMessageDate,
        unreadMessagesCount,
        isFavorite,
        className,
        isExpressBid,
    }) => {
        const toggleFavorite = (e) => {
            e.stopPropagation();
            if (this.state.loadingItems.includes(id)) {
                return;
            }

            this.setState({ loadingItems: this.state.loadingItems.concat(id) });

            this.props.toggleFavorite({ id, isFavorite: !isFavorite });
            (isFavorite ? removeChatFromFavorites({ chatId: id }) : addChatToFavorites({ chatId: id })).then((res) => {
                this.setState({ loadingItems: this.state.loadingItems.filter((item) => item !== id) });
                if (!res) {
                    this.props.toggleFavorite({ id, isFavorite });
                }
            });
        };
        return (
            <div
                key={`${id}_${unreadMessagesCount}`}
                className={cn("book-tr book-tr--col chat__item", {
                    "loading loading--small": this.state.loadingItems.includes(id),
                    [className]: !!className,
                })}
                onClick={() => this.toChat(id, unreadMessagesCount)}
            >
                <div className="book-tr__td-head pt-2 pb-1 pl-3">
                    <div className="book-tr__td-title font-weight-semibold">
                        {isExpressBid && <ExpressBidIcon />}
                        <span>{title}</span>
                    </div>
                    <div className="book-tr__td-date">
                        <i
                            className={cn("chat__favorite-icon icon-uEABA-star-solid", {
                                "chat__favorite-icon--selected": isFavorite,
                            })}
                            onClick={toggleFavorite}
                        />
                        {dateTimeToView(lastMessageDate)}
                    </div>
                </div>
                <div className="d-flex justify-content-between pb-1">
                    <div className="book-tr__td-body ellipsis py-1 pl-3">
                        <WithMentions text={text} />
                    </div>
                    <Notifys count={unreadMessagesCount} />
                </div>
            </div>
        );
    };

    getList = ({ filters, ...params }) => {
        const { getList } = this.props;
        getList(params);
    };

    renderListComponent = () => {
        return (
            <>
                {this.props.isLoadingList && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <List
                    {...this.props}
                    getList={this.getList}
                    renderRow={this.renderTableRow}
                    chatType={this.props.chatType}
                />
            </>
        );
    };

    setFilter = ({ name, value }) => {
        const { params, mergeParams } = this.props;
        params.start = 0;
        params.customFilters ||= {};

        if (!value || (Array.isArray(value) && value.length === 0)) {
            delete params.customFilters[name];
        } else {
            params.customFilters[name] = value;
        }

        params.preparedFilter = Object.entries(params.customFilters).reduce((acc, [key, value]) => {
            if (key === "onlyNew") {
                acc.unreadMessagesCount = { gt: 0 };
            } else {
                acc[key] = { in: value };
            }
            return acc;
        }, {});

        mergeFilters(mergeParams, { name: "custom", value: null }, params);
    };

    resetFilters = () => {
        const { params, mergeParams } = this.props;
        params.start = 0;
        params.customFilters = {};
        params.preparedFilter = {};
        mergeFilters(mergeParams, { name: "custom", value: null }, params);
    };

    render() {
        const { listRoute, params, mergeParams } = this.props;
        const selectProps = {
            ...defaultMultipleSelectProps,
            styles: { ...customFilterSelectStyles },
            components: { ValueContainer },
        };
        return (
            <Transition dir="full" {...listRoute}>
                <div className="page-book__list book-list list book-list--nofilter">
                    {this.renderHead()}
                    <div className="mb-2 d-flex justify-content-between container-fluid align-items-center">
                        <div className="w-250">
                            <Select
                                {...selectProps}
                                inputProps={{ name: "id" }}
                                url={trucksList}
                                placeholder="По машине"
                                onChange={this.setFilter}
                                propName="number"
                                value={params.customFilters?.id}
                            />
                        </div>
                        <div className="inline-btn inline-btn--refresh" onClick={() => mergeParams()}>
                            Обновить
                        </div>
                    </div>
                    {this.renderListComponent()}
                </div>
            </Transition>
        );
    }
}

export default connect(
    (state) => tableStateToProps(state, "car-chats"),
    (dispatch) => ({
        toggleFavorite: (params) => dispatch(carChatActions.toggleFavorite(params)),
        readAllCarChats: (params) => dispatch(carChatActions.readAllCarChats(params)),
        readCarChat: (params) => dispatch(carChatActions.readCarChat(params)),
        ...tableDispatchToProps(dispatch, generatedActions["car-chats"]),
    }),
)(CarChatsList);
